import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SelectOption from "components/select/SelectOption";
import { CircleCheck, Users } from "lucide-react";
import Button from "components/button";
import { Divider, Checkbox } from "antd";
import {
  getDepartmentList
} from "../../../../../redux/optionlist/optionlistState";
import {
  getEmployeeList
} from "../../../../../redux/employee/employeeState";
import {
  getEnrolledUsers
} from "../../../../../redux/trainingclass/trainingClassState"
import SearchFilter from "components/search/SearchFilter";

const SelectTeamCard = ({ 
  selectedMembers, 
  setSelectedMembers,
  departmentList,
  filters = {},
  getDepartment,
  pagination,
  doSearch,
  recordList,
  getUsers,
  selectedCourse, 
  enrolledUserIds,
}) => {

  const membersList = (recordList || []).map(emp => ({
    id: emp.emp_id,
    userId: emp.user_detail?.ude_user_id,
    initial: emp.employee_initials,
    name: emp.employee_name,
    role: emp.emp_title || "TBD",
    department_id: emp.emp_department_id,
  }));

  const filteredMembers = membersList.filter(member => {
    if (!filters?.department_id) return true;
      return member.department_id === filters.department_id;
  });

  const isSelected = (member) => selectedMembers.some(m => m.id === member.id);
  const isDisabled = (member) => enrolledUserIds?.includes(member.userId);
  
  const toggleMember = (member) => {
    if (enrolledUserIds.includes(member.userId)) return; 
    setSelectedMembers(prev =>
      isSelected(member)
        ? prev.filter(m => m.id !== member.id)
        : [...prev, member]
    );
  };


  const selectAll = () => {
    const selectableMembers = filteredMembers.filter(m => !enrolledUserIds.includes(m.userId));
    if (selectedMembers.length === selectableMembers.length) {
      setSelectedMembers([]);
    } else {
      setSelectedMembers(selectableMembers);
    }
  };

  useEffect(() => {
    getDepartment();
  }, [getDepartment]);

  useEffect(() => {
    if (selectedCourse?.id) {
      getUsers({ classeId: selectedCourse.id });
    }
  }, [selectedCourse?.id]);


  useEffect(() => {
    doSearch({paginate: pagination.per_page});
  }, [doSearch, pagination.per_page]);
  
  const onSelectFilter = (field, value) => {
    const data = {
      ...(filters || {}),
      page: 1,
      paginate: pagination?.per_page || 10,
    };

    if (value && value !== "all") {
      data[field] = value;
    } else {
      delete data[field];
    }
    
    doSearch(data);
  };


  return (
    <div className="space-y-4">
      <SearchFilter
        placeholder="Search by name, ID, or position..."
        searchHandler={doSearch} 
        filters={filters} 
        pagination={pagination}
      />

      <SelectOption
        placeholder="All Departments"
        options={departmentList}
        value={filters?.department_id}
        onChange={(value) => onSelectFilter("department_id", value)}
      />

      <Button
        onClick={selectAll}
        className="h-4 w-full flex items-center justify-center border-2 gap-1 transition-colors duration-200
                  hover:border-green-500 hover:bg-green-50 dark:text-white"
      >
        <CircleCheck size={16} />
        <span className="flex text-[13px]">
          {selectedMembers.length === filteredMembers.length ? "Deselect All" : "Select All"}
        </span>
      </Button>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="h-[300px] overflow-auto space-y-3 mt-2 pr-2">
        {filteredMembers.length > 0 ? (
          filteredMembers.map((member) => {
            const selected = isSelected(member);
            const disabled = isDisabled(member);

            return (
              <div
                key={member.id}
                className={`flex items-center gap-3 p-2.5 rounded-xl border-2 cursor-pointer transition-all
                  ${selected
                    ? "border-green-500 bg-green-50"
                    : "border-slate-200 hover:border-emerald-300 hover:bg-slate-50 dark:hover:bg-white/20"
                  }
                  ${disabled ? "opacity-50 cursor-not-allowed" : ""}
                `}
                onClick={() => !isDisabled(member) && toggleMember(member)}
              >
                <Checkbox
                  checked={selected}
                  disabled={disabled}
                  onChange={() => toggleMember(member)}
                  className="emerald-checkbox"
                />
                <div
                  className={`flex items-center justify-center w-10 h-10 border-2 border-white rounded-full text-[11px] font-semibold transition-all duration-300
                    ${disabled
                      ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                      : selected
                        ? "bg-gradient-to-br from-emerald-500 to-cyan-500 text-white"
                        : "bg-emerald-100 text-emerald-700 shadow-sm"
                    }`}
                >
                  {member.initial}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-[13px] truncate dark:text-white">{member.name}</p>
                  <p className="text-[11px] text-slate-700 truncate  dark:text-gray-100">{member.role}</p>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center py-12">
            <Users className="w-8 h-8 text-slate-900 mx-auto mb-4"/>
            <p className="text-slate-700">No employees found</p>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  departmentList: state.optionlist.departmentList?.items,
  recordList: state.employee.employeeList?.items,
  filters: state.employee.employeeList?.filters,
  pagination: state.employee.employeeList?.pagination,
  enrolledUserIds: state.trainingClass.enrolledUserIds,
});
const mapDispatchToProps = (dispatch) => ({
  getDepartment: (data) => dispatch(getDepartmentList(data)),
  doSearch: (filters) => dispatch(getEmployeeList(filters)),
  getUsers: (classeId) => dispatch(getEnrolledUsers(classeId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectTeamCard);

